module.exports = __webpack_public_path__ + "img/tuilogo.41c3701a.png";